function handleUSER_DID_NOT_ACCEPT_TERMS_OF_USE(context, form) {
  // eslint-disable-line camelcase
  context.loginHandler(form, true);
}

function handle2FA_NO_DEVICES(context, form, error) {
  const { response: tokens } = error;
  if (tokens) context.loginHandler(form, true, tokens);
}

function handle2FA_NO_TRUSTED(context, form, error) {
  const { response: tokens } = error;
  if (tokens) context.loginHandler(form, true, tokens);
}

function handleDefault(context, form) {
  form.$setPristine();
  return context.$state.go('home-view');
}

export default {
  handleUSER_DID_NOT_ACCEPT_TERMS_OF_USE,
  handle2FA_NO_DEVICES,
  handle2FA_NO_TRUSTED,
  handleDefault,
};



// WEBPACK FOOTER //
// ./src/modules/auth/helpers/login.js